import React from 'react'
import { Button, ButtonProps, StackProps, Stack, Text, Icon } from '@chakra-ui/core'

type OutlineButtonProps = ButtonProps

export const OutlineButton: React.FC<OutlineButtonProps> = ({
  children,
  variantColor = 'green',
  ...rest
}) => {
  return (
    <Button
      height="50px"
      rounded="lg"
      backgroundColor="white"
      border="2px solid"
      onFocus={(e) => e.preventDefault()}
      zIndex={48}
      borderColor={`${variantColor ? variantColor : 'green'}.400`}
      color={`${variantColor ? variantColor : 'green'}.400`}
      _hover={{
        backgroundColor: `${variantColor ? variantColor : 'green'}.400`,
        color: 'white',
        borderColor: 'transparent'
      }}
      fontSize="xs"
      {...rest}
    >
      {children}
    </Button>
  )
}

type PrimaryButtonProps = ButtonProps

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  variantColor = 'green',
  ...rest
}) => {
  return (
    <Button
      height="50px"
      rounded="lg"
      backgroundColor={`${variantColor ? variantColor : 'green'}.400`}
      border="2px solid"
      zIndex={48}
      onFocus={(e) => e.preventDefault()}
      borderColor="transparent"
      color="white"
      _hover={{
        backgroundColor: 'white',
        color: `${variantColor ? variantColor : 'green'}.400`,
        borderColor: `${variantColor ? variantColor : 'green'}.400`
      }}
      fontSize="xs"
      {...rest}
    >
      {children}
    </Button>
  )
}

type SecondaryButtonProps = {} & ButtonProps

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({ children, ...rest }) => {
  return (
    <Button
      height="50px"
      borderRadius="1rem"
      backgroundColor="gray.100"
      border="1px solid"
      zIndex={48}
      onFocus={(e) => e.preventDefault()}
      borderColor="gray.200"
      color="gray.700"
      _hover={{
        backgroundColor: 'gray.50',
        borderColor: 'gray.200'
      }}
      fontSize="xs"
      {...rest}
    >
      {children}
    </Button>
  )
}

export const BoxButton: React.FC<StackProps & { title: string; icon?: any }> = ({
  children,
  title,
  icon,
  ...rest
}) => {
  return (
    <Stack
      flex={1}
      rounded="md"
      px={1}
      py={3}
      onFocus={(e) => e.preventDefault()}
      transition="all 0.2s"
      cursor="pointer"
      bg="gray.100"
      spacing={1}
      {...rest}
    >
      <Icon as={icon} fontSize={19} color="green.400" />
      <Text>
        <Text fontSize="x-small" as="span">
          {title}
        </Text>
      </Text>
    </Stack>
  )
}
